import * as React from 'react';

function EmptyFavorites() {
  return (
    <div className="py-4 border-bottom">
      <p className="clearfix">
       <p><strong>Favorites</strong></p>
        <div >
          No stocks added in your favorites yet.
        </div>
      </p>
    </div>
  );
}

export default EmptyFavorites;
